export enum CurrencyTypesEnum {
  CASH = 'cash',
  NON_CASH = 'non-cash',
  CARD = 'card',
  TRANSFER = 'transfer',
  CROSS = 'cross',
}
